var map = {
	"./de/namespaces/globalSettings.js": [
		36905,
		7513
	],
	"./en/namespaces/globalSettings.js": [
		43297
	],
	"./es/namespaces/globalSettings.js": [
		41982,
		9094
	],
	"./fr/namespaces/globalSettings.js": [
		87593,
		1086
	],
	"./it/namespaces/globalSettings.js": [
		43631,
		3391
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 57167;
module.exports = webpackAsyncContext;